<button class="cart-button" [matBadge]="cartItems.length" matBadgePosition="below"
    matBadgeColor="primary" mat-raised-button [matMenuTriggerFor]="cartMenu">
        <img style="width: 35px;" src="assets/img/icons/shopping-cart.svg">
</button>
<mat-menu #cartMenu="matMenu" class="cart-menu">
    <h2 *ngIf="cartItems.length === 0" class="empty-cart">{{"newOrder.cart.titleEmpty" | translate}}</h2>
    <h2 *ngIf="lensesItems.length > 0" class="type-item-title">{{"home.orders.lenses" | translate}}</h2>
    <div *ngIf="lensesItems.length > 0" class="cart-items">
        <div *ngFor="let item of lensesItems" class="cart-item">
            <div class="d-flex">
                <div>
                    <div class="d-flex"><div class="key"><b>{{"newOrder.cart.commission" | translate}}:</b></div><div class="value"> {{item.commission}}</div></div>
                    <div class="d-flex"><div class="key"><b>{{"newOrder.cart.lensFamily" | translate}}:</b></div><div class="value"> {{item.article.name}}</div></div>
                    <div class="d-flex"><div class="key"><b>{{"newOrder.cart.side" | translate}}:</b></div><div class="value"> {{translateSide(item.side) | async}}</div></div>
                    <div class="d-flex"><div class="key"><b>{{"newOrder.cart.return" | translate}}:</b></div><div class="value"> {{translateReturnValue(item.isReturn) | async}}</div></div>
                </div>
                <div>
                    <img src="assets/img/icons/delete2.svg" class="delete-icon" (click)="deleteItem($event, item)">
                </div>
            </div>
        </div>
    </div>
    <h2 *ngIf="careItems.length > 0" class="type-item-title">{{"newOrder.equipment.care.title" | translate}}</h2>
    <div *ngIf="careItems.length > 0" class="cart-items">
        <div *ngFor="let item of careItems" class="cart-item">
            <div class="d-flex">
                <div>
                    <div class="d-flex"><div class="key"><b>{{"newOrder.cart.name" | translate}}:</b></div><div class="value"> {{item.article.name}}</div></div>
                    <div class="d-flex"><div class="key"><b>{{"newOrder.cart.count" | translate}}:</b></div><div class="value"> {{item.count}}</div></div>
                </div>
                <div>
                    <img src="assets/img/icons/delete2.svg" class="delete-icon" (click)="deleteItem($event, item)">
                </div>
            </div>
        </div>
    </div>
    <h2 *ngIf="accessoriesItems.length > 0" class="type-item-title">{{"newOrder.equipment.accessories.title" | translate}}</h2>
    <div *ngIf="accessoriesItems.length > 0" class="cart-items">
        <div *ngFor="let item of accessoriesItems" class="cart-item">
            <div class="d-flex">
                <div>
                    <div class="d-flex"><div class="key"><b>{{"newOrder.cart.name" | translate}}:</b></div><div class="value"> {{item.article.name}}</div></div>
                    <div class="d-flex"><div class="key"><b>{{"newOrder.cart.count" | translate}}:</b></div><div class="value"> {{item.count}}</div></div>
                </div>
                <div>
                    <img src="assets/img/icons/delete2.svg" class="delete-icon" (click)="deleteItem($event, item)">
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="lensesItems.length > 0 || careItems.length > 0 || accessoriesItems.length > 0" style="margin-top: 10px;">
        <button mat-flat-button color="primary" style="margin-left: 3%; margin-right: 5%;" (click)="confirmOrder($event)" class="action-button">{{"newOrder.buttons.confirm" | translate}}</button>
        <button mat-flat-button color="primary" (click)="deleteAll($event)" class="action-button">{{"newOrder.buttons.deleteAll" | translate}}</button>
    </div>
</mat-menu>
